import { useEffect, useState } from 'react';
import { imageStorage, imageFirestore, timestamp } from '../firebase/config';


const useStorage = (file) => {

    const [progress, setProgress] = useState(0);
    const [error, setError] = useState(null);
    const [url, setUrl] = useState(null);

    useEffect(() => {
        //references of imgs
        const storageRef = imageStorage.ref(file.name);
        const collectionRef = imageFirestore.collection('images');

        storageRef.put(file).on('state_changed', (snap) => {
            let percentage = (snap.bytesTransferred / snap.totalBytes) * 100;
            setProgress(percentage);
        }, (err) => {
            setError(err);
        }, async () => {
            const url = await storageRef.getDownloadURL();
            const createdAt = timestamp();
            collectionRef.add({ url, createdAt });
            setUrl(url);
        })
    }, [file]);

    return {progress, url, error}
}

export default useStorage;